import { useContext } from 'react';
import { useSelector } from 'react-redux';

import { Mode } from '../../../../../types';
import { ModeContext } from '../../../../../context';

import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { ServicesByType } from '../model/types';
import { checkoutCardExtraSelectors, checkinCardExtraSelectors } from '../model/selectors';

export function useCardExtraServices() {
	let cartExtraServicesByTypes: Partial<ServicesByType>;
	let availableCardExtraServices: Partial<Record<OrderAdditionalServiceGdsServiceServiceType, boolean>>;

	const mode = useContext(ModeContext);

	if (mode === Mode.Checkin) {
		cartExtraServicesByTypes = useSelector(checkinCardExtraSelectors.getCardExtraServicesByTypes);
		availableCardExtraServices = useSelector(checkinCardExtraSelectors.getAvailableCardExtraServicesTypes);
	} else {
		cartExtraServicesByTypes = useSelector(checkoutCardExtraSelectors.getCardExtraServicesByTypes);
		availableCardExtraServices = useSelector(checkoutCardExtraSelectors.getAvailableCardExtraServicesTypes);
	}

	return { cartExtraServicesByTypes, availableCardExtraServices };
}
